import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/admin/home/AdminHome.vue";
import store from "@/store";

Vue.use(VueRouter);
// const DEFAULT_TITLE =  window.location.host.includes("akindervolunteer") ? "aKinder™Volunteer" : "Volunteer IN NEPA";
const DEFAULT_TITLE =  process.env.VUE_APP_TITLE;
console.log('default title:', DEFAULT_TITLE);
const akinder_title = "aKinder™Volunteer"
const routes = [
  {
    path: "/",
    name: "root",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/home",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/agency/home",
    name: "agency-home",
    component: () =>
      import(
        /* webpackChunkName: "agency-home" */ "../views/agency/AgencyHome.vue"
      ),
    permission: ["Agency"],
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/agency/approval",
    name: "agency-approval",
    component: () =>
      import(
        /* webpackChunkName: "agency-approval" */ "../views/agency/AgencyApproval.vue"
      ),
    props: true,
    meta: { requiresAuth: true, title: `Agency Approval | ${DEFAULT_TITLE}` }
  },
  {
    path: "/agency/register",
    name: "agency-register",
    component: () =>
      import(
        /* webpackChunkName: "agency-register" */ "../views/getstarted/RegisterAgency.vue"
      ),
    props: true,
    meta: { requiresAuth: false, title: `Agency Register | ${DEFAULT_TITLE}` }
  },
  {
    path: "/business/register",
    name: "business-register",
    component: () =>
      import(
        /* webpackChunkName: "business-register" */ "../views/getstarted/RegisterBusiness.vue"
      ),
    props: true,
    meta: {
      requiresAuth: false,
      title: `Business Register | ${DEFAULT_TITLE}`
    }
  },
  {
    path: "/user/register",
    name: "user-register",
    component: () =>
      import(
        /* webpackChunkName: "volunteer-register" */ "../views/getstarted/RegisterVolunteer.vue"
      ),
    props: true,
    meta: {
      requiresAuth: false,
      title: `Volunteer Register | ${DEFAULT_TITLE}`
    }
  },
  {
    path: "/company/home",
    name: "company-home",
    component: () =>
      import(
        /* webpackChunkName: "company-home" */ "../views/company/CompanyHome.vue"
      ),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/volunteer/home",
    name: "volunteer-home",
    component: () =>
      import(
        /* webpackChunkName: "volunteer-home" */ "../views/volunteer/VolunteerHome.vue"
      ),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/needs",
    name: "agency-needs",
    permission: ["Agency","Volunteer"],
    component: () =>
      import(
        /* webpackChunkName: "agency-needs" */ "../views/agency/needs/AgencyNeeds.vue"
      ),
    children: [
      {
        path: "feeds",
        name: "agency-need-feeds",
        meta: {
          requiresAuth: true,
          title: `Agencies Needs | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/agency/needs/AgencyNeedFeeds.vue")
      },
      {
        path: "discover",
        name: "agency-need-discover",
        meta: {
          requiresAuth: true,
          title: `Agencie Needs | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/agency/needs/AgencyNeedDiscover.vue")
      },
      {
        path: "notification",
        name: "agency-need-notification",
        meta: {
          requiresAuth: true,
          title: `Agencie Needs | ${DEFAULT_TITLE}`
        },
        component: () =>
          import("../views/agency/needs/AgencyNeedNotification.vue")
      },
      {
        path: "details",
        name: "agency-need-details",
        component: () =>
          import(
            /* webpackChunkName: "agency-need-details" */ "../views/agency/needs/AgencyNeedDetails.vue"
          ),
        props: true,
        meta: { requiresAuth: false }
      },
      // agency-report
      {
        path: "report",
        name: "agency-report",
        component: () =>
          import(
            /* webpackChunkName: "agency-report" */ "../views/agency/needs/report/AgencyReportHome.vue"
          )
      }
    ],
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/chat",
    name: "chat",
    permission: ["Volunteer", "Agency"],
    component: () =>
      import(/* webpackChunkName: "notifications" */ "../views/chat/Chat.vue"),
    children: [
      {
        path: "details",
        name: "chat-details",
        meta: {
          requiresAuth: true,
          title: `Chat | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/chat/ChatMessages.vue")
      },
      {
        path: "empty",
        name: "no-messages",
        meta: {
          requiresAuth: true,
          title: `No messages | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/chat/NoMessages.vue")
      }
    ],
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/mobile-chat",
    name: "mobile-chat",
    meta: { requiresAuth: true, title: `Chat | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "notifications" */ "../views/chat/MobileChat.vue"
      )
  },
  {
    path: "/mobile-chat-room",
    name: "mobile-chat-room",
    meta: { requiresAuth: true, title: `Chat | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "notifications" */ "../views/chat/MobileChatMessages.vue"
      )
  },
  {
    path: "/agency-profile",
    name: "agency-profile",
    component: () =>
      import(
        /* webpackChunkName: "notifications" */ "../views/agency/profile/AgencyProfile.vue"
      ),
    children: [
      {
        path: ":id",
        name: "agency-profile-details",
        meta: {
          requiresAuth: true,
          title: `Profile | ${DEFAULT_TITLE}`
        },
        component: () =>
          import("../views/agency/profile/AgencyProfileDetails.vue"),
        children: [
          {
            path: "events",
            name: "agency-profile-events",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/agency/profile/AgencyProfileEvents.vue")
          },
          {
            path: "about",
            name: "agency-profile-about",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/agency/profile/AgencyProfileAbout.vue")
          },
          {
            path: "needs",
            name: "agency-profile-needs",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/agency/profile/AgencyProfileNeeds.vue")
          },
          {
            path: "volunteers",
            name: "agency-profile-volunteers",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/agency/profile/AgencyProfileVolunteers.vue")
          }
        ]
      }
    ],
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/company-profile",
    name: "company-profile",
    component: () =>
      import(
        /* webpackChunkName: "company-profile" */ "../views/company/profile/CompanyProfile.vue"
      ),
    children: [
      {
        path: ":id",
        name: "company-profile-details",
        meta: {
          requiresAuth: true,
          title: `Profile | ${DEFAULT_TITLE}`
        },
        component: () =>
          import("../views/company/profile/CompanyProfileDetails.vue"),
        children: [
          {
            path: "events",
            name: "company-profile-events",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/company/profile/CompanyProfileEvents.vue")
          },
          {
            path: "about",
            name: "company-profile-about",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/company/profile/CompanyProfileAbout.vue")
          },
          {
            path: "needs",
            name: "company-profile-needs",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/company/profile/CompanyProfileNeeds.vue")
          },
          {
            path: "agencies",
            name: "company-profile-agencies",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/company/profile/CompanyProfileAgencies.vue")
          }
        ]
      }
    ],
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/volunteer-profile",
    name: "volunteer-profile",
    permission: ["Volunteer", "Agency","Admin"],
    component: () =>
      import(
        /* webpackChunkName: "volunteer-profile" */ "../views/volunteer/profile/VolunteerProfile.vue"
      ),
    children: [
      {
        path: ":id",
        name: "volunteer-profile-details",
        meta: {
          requiresAuth: true,
          title: `Profile | ${DEFAULT_TITLE}`
        },
        component: () =>
          import("../views/volunteer/profile/VolunteerProfileDetails.vue"),
        children: [
          {
            path: "events",
            name: "volunteer-profile-events",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/volunteer/profile/VolunteerProfileEvents.vue")
          },
          {
            path: "about",
            name: "volunteer-profile-about",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/volunteer/profile/VolunteerProfileAbout.vue")
          },
          {
            path: "needs",
            name: "volunteer-profile-needs",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/volunteer/profile/VolunteerProfileNeeds.vue")
          },
          {
            path: "agencies",
            name: "volunteer-profile-agencies",
            meta: {
              requiresAuth: true,
              title: `Profile | ${DEFAULT_TITLE}`
            },
            component: () =>
              import("../views/volunteer/profile/VolunteerProfileAgencies.vue")
          }
        ]
      }
    ],
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/admin",
    name: "admin-home",
    component: Home,
    props: true,
    meta: {
      requiresAuth: true,
      title: `Admin | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    }
  },
  {
    path: "/admin/volunteers",
    name: "admin-volunteers",
    meta: {
      requiresAuth: true,
      title: `Volunteers | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-volunteers" */ "../views/admin/volunteer/AdminVolunteers.vue"
      ),
    props: true
  },
    {
    path: "/admin/manage",
    name: "admin-manage",
    meta: {
      requiresAuth: true,
      title: `Admin | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-volunteers" */ "../views/admin/admin/AdminManageHome.vue"
      ),
    props: true
  },
  {
    path: "/admin/members",
    name: "admin-members",
    meta: {
      requiresAuth: true,
      title: `Members | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-volunteers" */ "../views/admin/member/AdminMember.vue"
      ),
    props: true
  },
  {
    path: "/admin/agencies",
    name: "admin-agencies",
    meta: {
      requiresAuth: true,
      title: `Agencies | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-agencies" */ "../views/admin/agency/AdminAgencies.vue"
      ),
    props: true
  },
  {
    path: "/admin/events",
    name: "events",
    meta: {
      requiresAuth: true,
      title: `Events | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    },
    component: () =>
      import(/* webpackChunkName: "events" */ "../views/admin/AdminEvents.vue"),
    props: true
  },
  {
    path: "/admin/business",
    name: "admin-business",
    meta: {
      requiresAuth: true,
      title: `Business | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-business" */ "../views/admin/business/AdminBusinessHome.vue"
      ),
    props: true
  },
  {
    path: "/admin/company",
    name: "admin-company",
    meta: {
      requiresAuth: true,
      title: `Company | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-business" */ "../views/admin/company/AdminCompanyHome.vue"
      ),
    props: true
  },
  {
    path: "/admin/ads",
    name: "admin-ads",
    meta: {
      requiresAuth: true,
      title: `Ads | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-ads" */ "../views/admin/ads/AdminAdsHome.vue"
      ),
    props: true
  },
  {
    path: "/reported",
    name: "reported",
    meta: {
      requiresAuth: true,
      title: "Reported | Admin",
      permission: ["Admin"]
    },
    component: () =>
      import(
        /* webpackChunkName: "reported" */ "../views/admin/report/AdminReported.vue"
      ),
    props: true
  },
  {
    path: "/event-details",
    name: "Event details",
    meta: { requiresAuth: false },
    component: () =>
      import(
        /* webpackChunkName: "event-details" */ "../views/event_feeds/details/EventDetailsHome.vue"
      ),
    props: true
  },
  {
    path: "/notifications",
    name: "notifications",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "notifications" */ "../views/notification/NotificationHome.vue"
      ),
    props: true
  },
  {
    path: "/donations",
    meta: { requiresAuth: true },
    permission: ["Volunteer", "Agency"],
    component: () =>
      import(
        /* webpackChunkName: "donation-home" */ "../views/donation/DonationHome.vue"
      ),
    children: [
      {
        path: "",
        name: "donation-select-agency",
        meta: {
          requiresAuth: true,
          title: `Select Agency | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/donation/DonationSelectAgency.vue")
      },
      {
        path: "set-amount",
        name: "donation-set-amount",
        meta: {
          requiresAuth: true,
          title: `Set amount | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/donation/DonationSetAmount.vue")
      },
      {
        path: "payment",
        name: "donation-payment",
        meta: {
          requiresAuth: true,
          title: `Donation | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/donation/DonationPayment.vue")
      },
      {
        path: "success",
        name: "donation-success",
        meta: {
          requiresAuth: true,
          title: `Donation | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/donation/DonationSuccess.vue")
      },
      {
        path: "history",
        name: "donation-history",
        meta: {
          requiresAuth: true,
          title: `My Donations | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/donation/DonationHistory.vue")
      },
      {
        path: "details",
        name: "donation-details",
        meta: {
          requiresAuth: true,
          title: `Donation Details | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/donation/DonationDetails.vue")
      }
    ],
    props: true
  },
  {
    path: "/competition",
    name: "competition",
    meta: { requiresAuth: true, permission: ["Agency"] },
    component: () => import("../views/competition/CompetitionHome.vue"),
    props: true,
    children: [
      {
        path: "detailed-view/:id",
        name: "detailed-view",
        meta: {
          requiresAuth: true,
          permission: ["Agency","Volunteer"],
          title: `Team Challenges Detailed View | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/competition/DetailedView.vue")
      },
      {
        path: "history",
        name: "history",
        meta: {
          requiresAuth: true,
          permission: ["Agency","Volunteer"],
          title: `History | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/competition/CompetitionHistory.vue")
      },
      {
        path: "competition-responses",
        name: "competition-responses",
        meta: {
          requiresAuth: true,
          permission: ["Agency"],
          title: `Competition Responses | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/competition/CompetitionResponses.vue")
      },
      {
        path: "participated-responses",
        name: "participated-responses",
        meta: {
          requiresAuth: true,
          permission: ["Agency"],
          title: `Competition Participated Responses | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/competition/CompetitionPaticipatedResponses.vue")
      }
    ]
  },
  {
    path: "/agency-members",
    name: "agency-members",
    meta: { requiresAuth: true, permission: ["Agency"] },
    component: () => import("../views/members/MembersHome.vue"),
    props: true
  },
  {
    path: "/search",
    name: "search",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "search" */ "../views/search/SearchHome.vue"),
    props: true
  },
  {
    path: "/settings",
    name: "settings",
    meta: { requiresAuth: true, title: `Settings | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "../views/settings/SettingHome.vue"
      ),
    props: true
  },
  {
    path: "/admin-message",
    name: "admin-message",
    meta: {
      requiresAuth: true,
      title: `Message | ${DEFAULT_TITLE}`,
      permission: ["Admin"]
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-message" */ "../views/admin/message/AdminMessageHome.vue"
      ),
    props: true
  },
  {
    path: "/agency-message",
    name: "agency-message",
    meta: {
      requiresAuth: true,
      title: `Message | ${DEFAULT_TITLE}`,
      permission: ["Agency"]
    },
    component: () =>
      import(
        /* webpackChunkName: "agency-message" */ "../views/agency/message/AgencyMessageHome.vue"
      ),
    props: true
  },
  {
    path: "/need-map",
    name: "need-map",
    meta: { requiresAuth: true },
    permission: ["Volunteer", "Agency"],
    component: () =>
      import(
        /* webpackChunkName: "need-map" */ "../views/need_map/NeedMapHome.vue"
      ),
    props: true
  },
  {
    path: "/weather",
    name: "weather",
    meta: { requiresAuth: true },
    permission: ["Volunteer", "Agency"],
    component: () =>
      import(
        /* webpackChunkName: "weather" */ "../views/weather/WeatherHome.vue"
      ),
    props: true
  },
  {
    path: "/calendar",
    name: "calendar",
    meta: { requiresAuth: true },
    permission: ["Volunteer","Agency"],
    component: () =>
      import(
        /* webpackChunkName: "calendar" */ "../views/calendar/CalendarHome.vue"
      ),
    props: true
  },
  {
    path: "/awards",
    name: "awards",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "awards" */ "../views/awards/AwardsHome.vue"),
    props: true
  },
  {
    path: "/awards/details",
    name: "award-details",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "award-details" */ "../views/awards/AwardsDetails.vue"
      ),
    props: true
  },
  {
    path: "/volunteer-agencies",
    name: "volunteer-agencies",
    meta: { requiresAuth: true, title: `Agencies | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "volunteer-agencies" */ "../views/volunteer/agencies/VolunteerAgencies.vue"
      ),
    props: true
  },
  {
    path: "/company-agencies",
    name: "company-agencies",
    meta: { requiresAuth: true, title: `Agencies | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "company-agencies" */ "../views/company/agencies/CompanyAgencies.vue"
      ),
    props: true
  },
  {
    path: "/volunteer-diary",
    name: "volunteer-diary",
    meta: { requiresAuth: true, title: `Agencies | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "volunteer-diary" */ "../views/volunteer/response/VolunteerDiary.vue"
      ),
    props: true
  },
  {
    path: "/company-diary",
    name: "company-diary",
    meta: { requiresAuth: true, title: `Agencies | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "company-diary" */ "../views/company/response/CompanyDiary.vue"
      ),
    props: true
  },
  {
    path: "/agencies",
    name: "agencies",
    meta: { requiresAuth: true, title: `Agencies | ${DEFAULT_TITLE}` },
    permission: ["Agency", "Volunteer"],
    component: () =>
      import(
        /* webpackChunkName: "agencies" */ "../views/agency/agencies/Agencies.vue"
      ),
    props: true
  },
  {
    path: "/agency-volunteers",
    name: "agency-volunteers",
    meta: { requiresAuth: true, title: `Volunteers | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "agency-volunteers" */ "../views/agency/volunteers/AgencyVolunteers.vue"
      ),
    props: true
  },
  {
    path: "/agency-responses",
    name: "agency-responses",
    meta: { requiresAuth: true, title: `Responses | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "agency-responses" */ "../views/agency/responses/AgencyResponses.vue"
      ),
    children: [
      {
        path: "feeds",
        name: "agency-responses-feeds",
        meta: {
          requiresAuth: true,
          title: `Responses | ${DEFAULT_TITLE}`
        },
        component: () =>
          import("../views/agency/responses/AgencyResponsesSection.vue")
      },
      {
        path: "diary",
        name: "agency-responses-diary",
        meta: { requiresAuth: true, title: `Work Diary | ${DEFAULT_TITLE}` },
        component: () =>
          import(
            /* webpackChunkName: "agency-responses-diary" */ "../views/agency/responses/AgencyVolunteerDiary.vue"
          ),
        props: true
      }
    ],
    props: true
  },
  {
    path: "/volunteers",
    name: "volunteers",
    permission: ["Volunteer", "Agency"],
    meta: { requiresAuth: true, title: `Volunteers | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "volunteers" */ "../views/volunteer/volunteers/Volunteers.vue"
      ),
    props: true
  },
  {
    path: "/volunteer-hours",
    name: "volunteer-hours",
    meta: {
      requiresAuth: true,
      title: `Volunteers | ${DEFAULT_TITLE}`,
      permission: ["Volunteer"]
    },
    component: () =>
      import(
        /* webpackChunkName: "volunteers" */ "../views/volunteer/work_history/VolunteerHours.vue"
      ),
    props: true
  },
  {
    path: "/my-challenge",
    name: "my-challenge",
    meta: {
      requiresAuth: true,
      title: `Volunteers Member | ${DEFAULT_TITLE}`,
      permission: ["Volunteer", "Agency", "Company"]
    },
    component: () =>
      import(
        /* webpackChunkName: "join-as-member" */ "../views/members/MembersHome.vue"
      ),
    props: true,
    // children: [
    //   {
    //     path: "members-history",
    //     name: "members-history",
    //     meta: {
    //       requiresAuth: true,
    //       title: `Members History | ${DEFAULT_TITLE}`,
    //       permission: ["Volunteer", "Company"]
    //     },
    //     component: () =>
    //       import(
    //         /* webpackChunkName: "members-history" */ "../views/members/MembersHistory.vue"
    //       ),
    //     props: true
    //   }
    // ]
  },
  {
    path: "/edit-agency/:id",
    name: "edit-agency",
    meta: { requiresAuth: true, title: `Edit Agency | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "edit-agency" */ "../views/admin/agency/AdminEditAgency.vue"
      ),
    props: true
  },
  {
    path: "/support-center",
    name: "support-center",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "support-center" */ "../views/SupportCenter.vue"
      ),
    props: true,
  },
  {
    path: "/admin/donations",
    name: "admin-donations",
    meta: { requiresAuth: true, title: `Donations | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "admin-donations" */ "../views/admin/donations/AdminDonationsHome.vue"
      ),
    props: true,
          children: [
                {
                  path: "/agency-donation-details/:id",
                  name: "agency-donation-details",
                  meta: {
                    requiresAuth: true,
                    title: `Donations Details| ${DEFAULT_TITLE}`,
                    permission: ["Admin"]
                  },
                  component: () =>
                    import(
                      /* webpackChunkName: "members-history" */ "../views/admin/donations/AdminDonationsDetails.vue"
                    ),
                  props: true
                }
        ]
  },

  {
    path:"/admin/commissions",
    name: "admin-commissions",
    meta: { requiresAuth: true, title: `Commissions | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "admin-commissions" */ "../views/admin/commissions/AdminCommissionsHome.vue"
      ),
    props: true 
  },
  {
    path: "/blogs",
    name: "blogs",
    meta: { requiresAuth: true },
    permission: ["Volunteer", "Agency", "Admin"],
    component: () =>
      import(/* webpackChunkName: "blogs" */ "../views/blogs/BlogHome.vue"),
    children: [
      {
        path: "feeds",
        name: "blog-feeds",
        meta: {
          requiresAuth: true,
          title: `Blogs | ${DEFAULT_TITLE}`
        },
        component: () => import("../views/blogs/BlogFeeds.vue")
      },
      {
        path: "details",
        name: "blog-details",
        meta: { requiresAuth: false, title: `Blog | ${DEFAULT_TITLE}` },
        component: () =>
          import(
            /* webpackChunkName: "blog-details" */ "../views/blogs/BlogDetailsHome.vue"
          ),
        props: true
      },
      {
        path: "create",
        name: "create-blog",
        meta: { requiresAuth: true },
        component: () =>
          import(
            /* webpackChunkName: "create-blog" */ "../views/blogs/CreateBlog.vue"
          ),
        props: true
      },
      {
        path: "edit",
        name: "edit-blog",
        meta: { requiresAuth: true },
        component: () =>
          import(
            /* webpackChunkName: "edit-blog" */ "../views/blogs/EditBlog.vue"
          ),
        props: true
      }
    ],
    props: true
  },
  {
    path: "/admin-profile",
    name: "admin-profile",
    meta: { requiresAuth: true, title: `Admin Profile | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "admin-profile" */ "../views/admin/profile/AdminProfile.vue"
      ),
        permission: [ "Admin"],
    props: true
  },
  {
    path: "/colors",
    name: "colors",
    meta: { requiresAuth: true, title: `Admin Color | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "admin-profile" */ "../views/admin/color/AdminColourHome.vue"
      ),
      permission: [ "Admin"],
    props: true
  },
  {
    path: "/landing",
    name: "landing",
    meta: { requiresAuth: false, title: `${DEFAULT_TITLE}` },
    component: () => {
      if (DEFAULT_TITLE.includes(akinder_title)) {
        return import(
          /* webpackChunkName: "landing-akinder" */ "../views/getstarted/Landing.vue"
        );
      } else {
        return import(
          /* webpackChunkName: "landing-nepa" */ "../views/getstarted/nepaLanding.vue"
        );
      }
    },
    props: true
  },
  {
    path: "/login",
    name: "login",
    meta: { requiresAuth: false, title: `Login | ${DEFAULT_TITLE}` },
    component: () => {
      if (DEFAULT_TITLE.includes(akinder_title)) {
        return import(
          /* webpackChunkName: "login-akinder" */ "../views/getstarted/Login.vue"
        );
      } else {
        return import(
          /* webpackChunkName: "login-nepa" */ "../views/getstarted/nepaLogin.vue"
        );
      }
    },
    props: true
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    meta: { requiresAuth: false, title: `Forgot Password | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "forgot-password" */ "../views/getstarted/ForgotPassword.vue"
      ),
    props: true
  },
  {
    path: "/verification-code",
    name: "verification-code",
    meta: {
      requiresAuth: false,
      title: `Verification code | ${DEFAULT_TITLE}`
    },
    component: () =>
      import(
        /* webpackChunkName: "verification-code" */ "../views/getstarted/VerificationCode.vue"
      ),
    props: true
  },
  {
    path: "/reset-password",
    name: "reset-password",
    meta: { requiresAuth: false, title: `Reset password | ${DEFAULT_TITLE}` },
    component: () =>
      import(
        /* webpackChunkName: "reset-password" */ "../views/getstarted/ResetPassword.vue"
      ),
    props: true
  },
  {
    path: "/linker",
    name: "linker",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Linker.vue"),
    props: true
  },
  {
    path: "/privacy",
    name: "privacy",
    meta: {
      requiresAuth: false,
      title: `Privacy and Policy | ${DEFAULT_TITLE}`
    },
    component: () => {
      if (DEFAULT_TITLE.includes(akinder_title)) {
        return import(
          /* webpackChunkName: "policy-akinder" */ "../views/Policy.vue"
        );
      } else {
        return import(
          /* webpackChunkName: "policy-nepa" */ "../views/nepaPolicy.vue"
        );
      }
    },
    props: true
  },
  {
    path: "/child-support",
    name: "child-support",
    meta: {
      requiresAuth: false,
      title: `Child Support | ${DEFAULT_TITLE}`
    },
    component: () => {
      if (DEFAULT_TITLE.includes("aKinder")) {
        return import(
          /* webpackChunkName: "child-support-akinder" */ "../views/ChildSupport.vue"
        );
      } else {
        return import(
          /* webpackChunkName: "child-support-nepa" */ "../views/nepaChildSupport.vue"
        );
      }
    },
    props: true
  },
  {
    path: "/tos",
    name: "terms-of-service",
    meta: {
      requiresAuth: false,
      title: `Terms of Service | ${DEFAULT_TITLE}`
    },
    component: () => {
      if (DEFAULT_TITLE.includes(akinder_title)) {
        return import(
          /* webpackChunkName: "tos-akinder" */ "../views/TermsOfService.vue"
        );
      } else {
        return import(
          /* webpackChunkName: "tos-nepa" */ "../views/nepaTermsOfService.vue"
        );
      }
    },
    props: true
  },
 {
    path: "/aboutus",
    name: "aboutus",
    meta: {
      requiresAuth: false,
      title: `About | ${DEFAULT_TITLE}`
    },
    component: () => {
      if (DEFAULT_TITLE.includes(akinder_title)) {
        return import(
          /* webpackChunkName: "about-akinder" */ "../views/About.vue"
        );
      } else {
        return import(
          /* webpackChunkName: "about-nepa" */ "../views/nepaAbout.vue"
        );
      }
    },
    props: true
  },
  {
    path: "/facebook-callback",
    name: "facebook-callback",
    meta: {
      requiresAuth: false,
      title: `${DEFAULT_TITLE}`
    },
    component: () =>
      import(
        /* webpackChunkName: "users" */ "../views/settings/social_callbacks/FacebookCallback.vue"
      ),
    props: true
  },
  {
    path: "/instagram-callback",
    name: "instagram-callback",
    meta: {
      requiresAuth: false,
      title: `${DEFAULT_TITLE}`
    },
    component: () =>
      import(
        /* webpackChunkName: "users" */ "../views/settings/social_callbacks/InstagramCallback.vue"
      ),
    props: true
  },
  {
    path: "/linkedin-callback",
    name: "linkedin-callback",
    meta: {
      requiresAuth: false,
      title: `${DEFAULT_TITLE}`
    },
    component: () =>
      import(
        /* webpackChunkName: "users" */ "../views/settings/social_callbacks/LinkedInCallback.vue"
      ),
    props: true
  },
  {
    path: "/twitter-callback",
    name: "twitter-callback",
    meta: {
      requiresAuth: false,
      title: `${DEFAULT_TITLE}`
    },
    component: () =>
      import(
        /* webpackChunkName: "users" */ "../views/settings/social_callbacks/TwitterCallback.vue"
      ),
    props: true
  },
  {
    path: "/tiktok-callback",
    name: "tiktok-callback",
    meta: {
      requiresAuth: false,
      title: `${DEFAULT_TITLE}`
    },
    component: () =>
      import(
        /* webpackChunkName: "users" */ "../views/settings/social_callbacks/TiktokCallback.vue"
      ),
    props: true
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/NotFound.vue")
  },
  {
    path: "/*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || DEFAULT_TITLE;
  
  // Handle root path intelligently
  if (to.path === '/') {
    if (store.getters["auth/isAuthenticated"]) {
      // Redirect authenticated users to their respective home page
      const userType = store.getters["auth/getType"];
      if (userType === 'Agency') {
        next({ name: "agency-home" });
        return;
      } else if (userType === 'Volunteer') {
        next({ name: "volunteer-home" });
        return;
      } else if (userType === 'Company') {
        next({ name: "company-home" });
        return;
      } else if (userType === 'Admin') {
        next({ name: "admin-home" });
        return;
      } else {
        next({ name: "home" });
        return;
      }
    } else {
      // Redirect unauthenticated users to login
      next({ name: "login" });
      return;
    }
  }
  
  if (to.meta.requiresAuth) {
    if (store.getters["auth/isAuthenticated"]) {
      // Check if profile is loaded, if not, fetch it
      if (!store.state.auth.profile || !store.state.auth.profile._id) {
        try {
          await store.dispatch("auth/fetchProfile");
        } catch (error) {
          console.error("Error fetching profile:", error);
          next({
            name: "login",
            query: {
              redirect: to.fullPath
            }
          });
          return;
        }
      }
      
      if (
        to.meta.permission &&
        !to.meta.permission.includes(store.getters["auth/getType"])
      ) {
        // Redirect to appropriate home page based on user type
        const userType = store.getters["auth/getType"];
        if (userType === 'Agency') {
          next({ name: "agency-home" });
        } else if (userType === 'Volunteer') {
          next({ name: "volunteer-home" });
        } else if (userType === 'Company') {
          next({ name: "company-home" });
        } else {
          next({ name: "login" });
        }
        return;
      } else {
        next();
        store.commit("chat/setRoute", to);
      }
    } else {
      next({
        name: "login",
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});

router.onError(error => {
  if (/loading chunk [a-z0-9-]* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
